import { createApi } from '@reduxjs/toolkit/query/react'
import { CREATE_GOAL, LIST_GOAL, REMOVE_GOAL, REMOVE_GOAL_CONTEXT, UPDATE_GOAL, VIEW_GOAL } from "config/apiPaths"
import { DISCIPLINES_LIST } from "config/paths";
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const goalsApi = createApi({
  reducerPath: 'goalsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: "/goal",
  }),
  tagTypes: ["Goals"],
  endpoints: (builder) => ({
    // get goals list
    getGoalsList: builder.query({
      query: ({ search = "", status = "", discipline_id = "", discipline_area = "", page = 1, limit = 10, sort = { column: "title", direction: "ASC" } }) => ({
        method: "PATCH",
        url: LIST_GOAL,
        data: {
          search,
          status,
          page,
          limit,
          discipline_id,
          discipline_area,
          sort,
        },
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["Goals", "GoalDetails"]
    }),

    // get goal data
    getGoalData: builder.query({
      query: (id) => ({
        method: "GET",
        url: `${VIEW_GOAL}/${id}`
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["GoalDetails"]
    }),

    // create goal
    createGoal: builder.mutation({
      query: (data) => ({
        method: "POST",
        url: CREATE_GOAL,
        data
      }),
      invalidatesTags: ["Goals"]
    }),

    // update goal
    updateGoal: builder.mutation({
      query: (data) => ({
        method: "PUT",
        url: `${UPDATE_GOAL}/${data.id}`,
        data: data.payload
      }),
      invalidatesTags: ["Goals", "GoalDetails"]
    }),

    // delete goal
    deleteGoal: builder.mutation({
      query: (id) => ({
        method: "DELETE",
        url: `${REMOVE_GOAL}/${id}`
      }),
      invalidatesTags: ["Goals", "GoalDetails"]
    }),

    // delete goal context
    deleteGoalContext: builder.mutation({
      query: (id) => ({
        method: "DELETE",
        url: `${REMOVE_GOAL_CONTEXT}/${id}`
      }),
      invalidatesTags: ["Goals", "GoalDetails"]
    }),
  }),
})

export const {
  useGetGoalsListQuery,
  useCreateGoalMutation,
  useGetGoalDataQuery,
  useUpdateGoalMutation,
  useDeleteGoalMutation,
  useDeleteGoalContextMutation
} = goalsApi;